import { render, staticRenderFns } from "./DentalAppointmentModalConfirm.vue?vue&type=template&id=4afb43a9&"
import script from "./DentalAppointmentModalConfirm.vue?vue&type=script&lang=js&"
export * from "./DentalAppointmentModalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports